<div class="wrap-x wrap-l wrap-m m-t-15 m-t-0-s m-b-15 p-b-15 p-b-0-s m-b-7-s center">
    @if (!registerPageIsVisible) {
    <div class="w-12 p-t-10 p-t-1-s"
         style="max-width:1126px;">
        <div class="left m-b-15 p-b-10 m-b-0-s p-b-0-s flex flex-column-s">
            <div
                 class="w-6 w-12-s b-r b-b-s b-col-1026 b-r-0-s p-t-11 p-b-11 p-b-12-s m-b-6-s p-r-13 p-l-8 p-l-4-s p-r-4-s center-s">
                <h2 class="col-1 inline-block"
                    [sizeClass]="'S:h4,!S:h3'"
                    translate>Welcome back</h2>
                <p class="p1 col-1 m-t-1">Sign in to access your account.</p>
                <form class="m-t-6 m-t-8-s"
                      #form="ngForm"
                      method="post"
                      [attr.sl-form]="'login'">


                    <!-- email field (for all forms) -->
                    <input-wrap [messages]="{validatePatternemail: 'This email address is invalid, please try again'}">
                        <input class="input"
                               type="email"
                               name="email"
                               sl-input="email"
                               cy-loginMailInput
                               [(ngModel)]="email"
                               [ngModelOptions]="{updateOn: 'blur'}"
                               validatePattern="email"
                               maxlength="80"
                               required
                               #emailInput
                               autocomplete="email"
                               (keyup.enter)="emailInput.blur()"
                               [muiInput]="'Email address'">
                    </input-wrap>
                    <!-- log in form -->
                    <div>
                        <input-wrap class="block m-t-3-s m-t">
                            <input class="input"
                                   type="password"
                                   name="password"
                                   cy-loginPwdInput
                                   required
                                   [(ngModel)]="data.password"
                                   (keyup.enter)="login()"
                                   [muiInput]="'Password'">
                        </input-wrap>
                        <!-- action button -->
                        <div class="m-t-16 m-t-7-s p-t-1 pos-relative ">

                            <div class="w-6 w-12-s p-r-2 p-r-0-s">
                                <action [status]="loginStatus"
                                        class="button w-12"
                                        sl-button="login"
                                        cy-loginSignIn
                                        (click)="login()">
                                    <span class="p1"
                                          translate>Sign in</span>
                                </action>
                            </div>
                            <div class="w-6 w-12-s p-l-2 p-l-0-s m-t-3-s">
                                <action [status]="passwordStatus"
                                        sl-button="reset"
                                        class="button-1 w-12"
                                        (click)="resetPassword()">
                                    <span class="p1"
                                          translate>Forgot password?</span>
                                </action>
                            </div>
                            <div class="pos-absolute top-100">
                                <result class="p2"
                                        [status]="passwordStatus"
                                        sl-result="reset"
                                        success="We’ve sent you an email with a link to reset your password."></result>
                                <result class="p2"
                                        sl-result="login"
                                        cy-loginSignInMsg
                                        [status]="loginStatus"></result>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div
                 class="w-6 w-12-s p-t-11 p-t-6-s p-b-11 p-b-12-s p-r-8 p-l-13 flex flex-column flex-grow flex-justify-between p-l-4-s p-r-4-s center-s">
                <div>
                    <h2 class="col-1 inline-block"
                        [sizeClass]="'S:h4,!S:h3'"
                        translate>New to Barker and Stonehouse?</h2>
                    <p class="p1 col-1 m-t-1">Create an account.</p>
                    <p class="p1 col-104 m-t-6 m-t-8-s">Creating an account has many benefits. You'll be able to check
                        out
                        faster,
                        create a wish
                        list, view your previous orders, and more.</p>
                </div>
                <button class="button-1 w-12 m-t-9-s"
                        type="button"
                        (click)="showRegisterForm(true)"
                        sl-login-label="header"
                        cy-loginConfirm>
                    <span class="p1"
                          translate>Create an account</span>
                </button>
            </div>
        </div>
        <div class="p-a-11 p-t-12-s p-b-12-s p-l-4-s p-r-4-s bg-col-51 m-b-15 m-b-0-s b-b-s b-t-s b-col-4">
            <div class="w-6 w-10-m w-12-s center">
                <h2 class="inline-block"
                    [sizeClass]="'S:h4,!S:h3'"
                    translate>Trade Customer</h2>
                <p class="p1 p-l-6 p-r-6 p-l-0-s p-r-0-s m-t-1">Apply for a trade account with us, and let our
                    specialists help you bring your
                    design
                    visions
                    to life!</p>
                <button [optHref]="'/trade-enquiries'"
                        class="button-1 w-10 w-12-s m-t-6 m-t-8-s p-l-0 p-r-0"
                        (click)="login()">
                    <span class="p1"
                          translate>Apply for trade account</span>
                </button>
            </div>
        </div>
    </div>
    }
    @if (registerPageIsVisible) {
    <h2 class="h2 col-1 inline-block center m-b-11 m-t-10 m-t-9-s w-9-s w-12"
        [sizeClass]="'S:h4,!S:h2'">{{'Create your Barker and Stonehouse account' | translate}}
    </h2>
    <form class="w-12 left p-l-4-s p-r-4-s"
          style="max-width:660px;"
          #form="ngForm"
          method="post"
          [attr.sl-form]="'register'">
        <h3 class="h4 col-1 inline-block m-b"
            translate>Personal information</h3>
        <!-- email field (for all forms) -->
        <input-wrap [messages]="{validatePatternemail: 'This email address is invalid, please try again'}">
            <input class="input"
                   type="email"
                   name="email"
                   sl-input="email"
                   cy-loginMailInput
                   [(ngModel)]="email"
                   [ngModelOptions]="{updateOn: 'blur'}"
                   validatePattern="email"
                   maxlength="80"
                   required
                   #emailInput
                   autocomplete="email"
                   (keyup.enter)="emailInput.blur()"
                   [muiInput]="'Email address'">
        </input-wrap>

        <!-- create account form -->
        <div class="pos-relative register-form">
            <!-- first name -->
            <input-wrap class="block m-t-3">
                <input class="input"
                       type="text"
                       name="firstname"
                       sl-input="firstname"
                       cy-registerFnameInput
                       [(ngModel)]="registerData.firstname"
                       [muiInput]="'First name'"
                       required>
            </input-wrap>
            <!-- last name -->
            <input-wrap class="block m-t-3">
                <input class="input"
                       type="text"
                       name="lastname"
                       sl-input="lastname"
                       cy-registerLnameInput
                       [(ngModel)]="registerData.lastname"
                       [muiInput]="'Last name'"
                       required>
            </input-wrap>
            <h3 class="h4 col-1 inline-block m-b m-t-11"
                translate>Password</h3>
            <input-wrap class="block">
                <input class="input"
                       type="password"
                       name="password"
                       placeholder="Password"
                       required
                       [(ngModel)]="data.password"
                       [muiInput]="'Password'">
            </input-wrap>
            <!-- dummy input for autocomplete issue with confirm password field -->
            <input class="pos-absolute"
                   style="opacity: 0;"
                   type="text"
                   name="dummy">
            <input-wrap class="block m-t-3"
                        [messages]="{validateEqual: 'Password and its confirmation do not match'}">
                <input class="input"
                       type="password"
                       name="confirmPassword"
                       placeholder="Password"
                       required
                       [(ngModel)]="registerData.confirmPassword"
                       matchCheck="password"
                       [muiInput]="'Confirm password'">
            </input-wrap>
            <!-- opt in -->
            <h3 class="h4 col-1 inline-block m-b m-t-11"
                translate>Sign up to our newsletter</h3>
            <p class="p1">
                <span>{{ 'By signing up to receive our newsletter you accept our' | translate }}&nbsp;</span>
                <a class="link"
                   target="_blank"
                   routerLink="/privacy-policy">{{ 'Privacy policy' | translate }}</a>&nbsp;
                <span>{{ 'and' | translate }}&nbsp;</span>
                <a class="link"
                   target="_blank"
                   routerLink="/terms-and-conditions">{{'Terms & Conditions' | translate }}</a>.
            </p>
            <radio-group class="block m-t-5 p-l-1 m-b left"
                         name="newsletter"
                         [(ngModel)]="registerData.newsletter">
                <radio class="block m-b-2 m-b-3-s"
                       value="1">
                    <span class="s1"
                          translate>Yes, please</span>
                </radio>
                <radio value="0">
                    <span class="s1"
                          translate>No, thank you</span>
                </radio>
            </radio-group>
            <!-- login button -->
            <div class="pos-relative">
                <action [status]="registerStatus"
                        class="button w-12 m-t-7"
                        sl-button="login"
                        cy-loginSignUp
                        (click)="register()">
                    <span class="p1"
                          translate>Create account</span>
                </action>
                <result class="p2 p-t-1"
                        sl-result="login"
                        cy-loginSignUpMsg
                        [status]="registerStatus"></result>
            </div>
        </div>

    </form>
    }
</div>